import { ActivityItemService } from 'core/services/activityItem.abstract.service';
import { PaperEvaluationModel } from 'core/models/elements/evaluations/paperEvaluation.model';
import { PaperQuestionModel } from 'core/models/elements/questions/paperQuestion.model';
import { PaperQuestionAnswerModel } from 'core/models/elements/answers/paperQuestionAnswer.model';
import { PaperQuestionAnswerCommand } from 'core/commands/elements/answers/paperQuestionAnswer.command';

export class PaperQuestionService extends ActivityItemService {
  async answer(activitySessionId, activityItemId, paperQuestionAnswer) {
    if (!(paperQuestionAnswer instanceof PaperQuestionAnswerModel)) {
      throw new TypeError(
        'The answer must be an instance of class "PaperQuestionAnswerModel"',
      );
    }
    const paperQuestionAnswerCommand = new PaperQuestionAnswerCommand(
      paperQuestionAnswer,
    );
    return await super.answer(
      activitySessionId,
      activityItemId,
      paperQuestionAnswerCommand,
    );
  }

  /**
   * A paper question is answered outside of the player, it cannot be evaluated here:
   * the answer is always complete and never blocks the student.
   */
  evaluate(paperQuestion, paperQuestionAnswer) {
    if (!(paperQuestion instanceof PaperQuestionModel)) {
      throw new TypeError(
        'The question must be an instance of class "PaperQuestionModel"',
      );
    }
    if (!(paperQuestionAnswer instanceof PaperQuestionAnswerModel)) {
      throw new TypeError(
        'The answer must be an instance of class "PaperQuestionAnswerModel"',
      );
    }

    // Same as a free text question without expected answers: nothing to compare, full score
    const evaluation = new PaperEvaluationModel(paperQuestion);
    evaluation.isCorrect = true;
    evaluation.rawScore = paperQuestion.gradingScale;
    evaluation.scaledScore = 1;
    evaluation.isAnswerComplete = true;

    return evaluation;
  }

  prepareAnswerAndEvaluation(item) {
    const answer = new PaperQuestionAnswerModel({ quizItemId: item.id });

    return {
      answer,
      evaluation: this.evaluate(item, answer),
    };
  }
}
